<template>
  <div>
    <v-card :color="archivado ? 'grey lighten-3' : 'primary'" class="card documento-card" height="100%">
      <v-card-title class="font-weight-bold justify-center">
        {{ documento.TipoDocumento ? documento.TipoDocumento.title : '' }}
      </v-card-title>
      <v-card-text align="center" class="contenido-card">
        <template v-if="documento.URL">
          <v-img :src="documento.URL" contain v-if="getDocumentType(documento.nombre) === 'img'">
            <template v-slot:placeholder>
              <v-row class="fill-height ma-0" align="center" justify="center">
                <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
              </v-row>
            </template>
          </v-img>
          <embed
            v-else-if="getDocumentType(documento.nombre) === 'pdf'"
            width="100%"
            class="pdf"
            name="plugin"
            :src="documento.URL + '#toolbar=0&navpanes=0&scrollbar=0'"
            type="application/pdf"
          />
        </template>
        <template v-else>
          <v-container>
            <v-row>
              <v-col cols="12">
                <div class="text-subtitle-2">No se encontró la URL del documento</div>
              </v-col>
            </v-row>
          </v-container>
        </template>
        <div v-if="archivado" class="text-caption mt-2">Archivado</div>
      </v-card-text>
      <v-spacer></v-spacer>
      <v-card-actions v-if="!archivado">
        <v-spacer></v-spacer>
        <v-btn icon class="menu-button primary--text" @click="openConfirmArchive(documento)" v-if="openConfirmArchive">
          <v-icon>mdi-archive</v-icon>
        </v-btn>
        <v-btn v-if="openEditModal" @click="openEditModal(documento)" icon class="menu-button primary--text">
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  name: 'DocumentoCard',
  props: {
    documento: {
      type: Object,
      required: true,
    },
    openConfirmArchive: {
      type: Function,
      default: null,
    },
    archivado: {
      type: Boolean,
      default: false,
    },
    archiveDocument: {
      type: Function,
      default: null,
    },
    openEditModal: {
      type: Function,
      default: null,
    },
  },
  methods: {
    getDocumentType(nombre) {
      if (!nombre) return ''
      const ext = nombre.split('.').pop().toLowerCase()
      if (['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp'].includes(ext)) return 'img'
      if (ext === 'pdf') return 'pdf'
      return ''
    },
  },
}
</script>

<style scoped>
.documento-card {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 230px;
}
.contenido-card {
  flex: 1 1 auto;
}
.pdf {
  height: 270px;
  overflow: hidden !important;
}
</style>
